/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { UserRound } from 'lucide-react';

/* Import context functions */
import { useI18n } from '@/context/I18nContext';

/* Import configuration */
import { APP_ROUTES } from '@/config/appRoutes';

/* Import components */
import OverviewAggregatedCard from '@/components/tabs/overview/metrics/cards/OverviewAggregatedCard';

/* Import types */
import type { OverviewCustomerCardData } from '@/lib/overview/overviewSystemAggregation';

interface OverviewCustomerCardProps {
    card: OverviewCustomerCardData;
    showKpis: boolean;
}

function OverviewCustomerCard({ card, showKpis }: OverviewCustomerCardProps) {
    const { t } = useI18n();
    const description = t('Metrics from customer {customer}.', { customer: card.customer });

    return (
        <OverviewAggregatedCard
            ariaLabel={description}
            card={card}
            description={description}
            icon={UserRound}
            showKpis={showKpis}
            title={card.customer}
            to={`${APP_ROUTES.clients}/${encodeURIComponent(card.customer)}`}
        />
    );
}

export default OverviewCustomerCard;
